import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { IGymData } from "../types";
import { IGymListing } from "../../models/GymListing";
import { GymListingService } from "../../services/gymListing.service";

export const useGetGymByIdQuery = (data: IGymData) => {
  return useQuery<IGymListing, Error>({
    queryKey: [QUERY_CONSTANTS.GET_GYM_BY_ID, data?.id],
    queryFn: () => GymListingService.getById(data).then((res) => res.data),
    enabled: !!data.id,
  });
};
